import { render, staticRenderFns } from "./NewInseminacion.vue?vue&type=template&id=421a064d"
import script from "./NewInseminacion.vue?vue&type=script&lang=js"
export * from "./NewInseminacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports